import React from 'react';

import { UncontrolledPopover, PopoverBody, Alert } from 'reactstrap';

import './releaseEDT.css';

const calculateBusinessDays = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  
  start.setDate(start.getDate() + 1);
  
  let businessDays = 0;
  const current = new Date(start);
  
  while (current <= end) {
    const dayOfWeek = current.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      businessDays++;
    }
    current.setDate(current.getDate() + 1);
  }
  
  return businessDays;
};

const ReleaseEDT = ({
  id,
  status,
  estimated_delivery_time,
}) => {
  const rowId = "release-row-edt-" + id.toString();
  let showStatusNote = false;
  
  if(!["locked", "approval", "delivering"].includes(status) || estimated_delivery_time === null) {
    showStatusNote = false;
  }
  else {
    showStatusNote = true;
  }

  let estimatedDeliveryDate = new Date(estimated_delivery_time);
  let today = new Date();
  
  let businessDays = calculateBusinessDays(today, estimatedDeliveryDate);
  let edtHasPassed = today > estimatedDeliveryDate;

  return (
    <div>
      <i className={"fas fa-clock fa-2x edt-icon " + (showStatusNote ? "edt-avl-icon" : "")} id={rowId} aria-hidden="true" disabled={!showStatusNote}></i>
      <UncontrolledPopover trigger="legacy" id="edt-popover" placement="bottom" target={rowId} disabled={!showStatusNote}>
        <PopoverBody style={{padding: "0px"}}>
        { showStatusNote && <>
            { edtHasPassed &&
              <Alert color="info" style={{fontSize: "14px", fontWeight: "bolder", "color": "info", margin: "0px"}} fade={true} isOpen={showStatusNote}>
                Release is in queue and will be delivered at the earliest possible time. While most deliveries occur within the estimated timeframe, occasional delays may happen due to holidays, high demand, or unforeseen circumstances, including those arising from DSP (stores). Thank you for your patience.
              </Alert>
            }
            { !edtHasPassed &&
              <Alert color="info" style={{fontSize: "14px", "color": "info", margin: "0px"}} fade={true} isOpen={showStatusNote}>
                Estimated Delivery in <strong>{businessDays} business day{businessDays > 1 ? "s" : ""} ({estimatedDeliveryDate.toLocaleDateString()})</strong>
              </Alert>
            }
          </>
        }
        </PopoverBody>
      </UncontrolledPopover>
    </div>
  );
};

export default ReleaseEDT;